import TagsListAffectedManager from './TagsListAffectedManager'

export default TagsListAffectedManager
